import React, { useMemo } from 'react';
import useTranslation from '~/app/hooks/useTranslation';
import { WorkOrderDetail } from '~/workorder/types';
import classes from './style.module.scss';

export interface OperatingTimeProps {
    excavator: WorkOrderDetail['excavator'];
    operatingTime: WorkOrderDetail['operatingTime'];
    operatingCount: WorkOrderDetail['operatingCount'];
}

export type OperatingTimeComponent = React.FC<OperatingTimeProps>;

const EMPTY_VALUE = '—';

const formatMetric = (value: number | null): string => {
    if (value === null || value === undefined) {
        return EMPTY_VALUE;
    }
    return String(value);
};

const OperatingTime: OperatingTimeComponent = ({ excavator, operatingTime, operatingCount }) => {
    const { t } = useTranslation('workorder');

    const showTime = !!excavator?.isOperatingTimeVisible;
    const showCount = !!excavator?.isOperatingCountVisible;

    const visible = useMemo(() => showTime || showCount, [showTime, showCount]);

    if (!visible) {
        return null;
    }

    return (
        <div className={classes['card']}>
            <h2 className={classes['title']}>{t('detail.operatingData')}</h2>
            <div className={classes['grid']}>
                {showTime && (
                    <div>
                        <span className={classes['field-label']}>{t('detail.operatingTimeHours')}</span>
                        <span className={classes['field-value']}>{formatMetric(operatingTime)}</span>
                    </div>
                )}
                {showCount && (
                    <div>
                        <span className={classes['field-label']}>{t('detail.operatingCountHours')}</span>
                        <span className={classes['field-value']}>{formatMetric(operatingCount)}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OperatingTime;
